<ax-value-edit
  type="URL"
  [form]="valueControl"
  [name]="name"
  [autofocus]="autofocus"
  [label]="label"
  [hint]="hint"
  [required]="required"
  [icon]="showIcon ? customIcon ?? 'link' : undefined"
  [errorsTemplate]="errorsTemplate"
  [readonly]="readonly"
  [enableValidation]="enableValidation"
  [subscriptSizing]="subscriptSizing"
></ax-value-edit>

<ng-template #errorsTemplate>
  <ax-property-error [form]="form" [label]="label"></ax-property-error>
</ng-template>
